import { MuiStylesType } from 'model/muiStyles.model';

export const muiStyles: MuiStylesType = {
  grid: {
    display: 'grid',
    gridTemplateColumns: {
      xs: 'repeat(auto-fill, minmax(270px, 1fr))',
      sm: 'repeat(auto-fill, minmax(320px, 1fr))',
      md: 'repeat(auto-fill, minmax(340px, 1fr))',
      lg: 'repeat(auto-fill, minmax(400px, 1fr))',
      xl: 'repeat(auto-fill, minmax(450px, 1fr))',
    },
    gap: '24px',
    overflowY: 'auto',
    gridAutoRows: 'min-content',
    gridAutoFlow: 'row',
    height: { xs: 'calc(100vh - 190px)', xl: 'calc(100vh - 200px)' },
    alignItems: 'stretch',
  },
};
